<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Job Posting"
                btnTitle="Add New"
                :showAddNew="true"
                @onClickAddNewButton="onClickAddNewButton"
            />
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
            <ListTable :tableItems="tableItems" :isJobPost="true"/>
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import ListTable from '@/components/molecule/company/hrm-payroll/job-requisition/ListTable.vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const params = ref({
    offset: 10,
});

const token = computed(() => localStorage.getItem('token'));

const {
  fetchJobRequisition
} = handleHrPayroll()

const onClickToGo = () => {
   getJobRequisitionList();
}

function onClickAddNewButton() {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.is_job_post = true;

  router.push({
    name:  'job-requisition-add',
    params: param,
    query: query
  })
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getJobRequisitionList();
}
const getJobRequisitionList = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchJobRequisition(query).then(res => {
        if (!res.status){
            store.commit("resetPagination")
            return
        }

        tableItems.value = res.data.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    query += '&offset=' + params.value.offset;
    query += '&status=approved'
    return query;
}

onMounted(() => {
    Promise.all([
       getJobRequisitionList(),
    ])
})
</script>
